import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouchWithAranGroup from "./sections/GetInTouchWithAranGroup";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouchWithAranGroup />
      <ContactInformation />
      <Footer />
    </div>;
}